import { kycState } from '../../model/details/kycState';

// Types
import { LeadDetailRawType } from '../../types/Lead';

export default function transformKycState(data: LeadDetailRawType) {
    const map = new Map();
    let _transform = {};

    map.set('identification.identificationProvider', 'identificationProvider');
    map.set('identification.status', 'status');
    map.set('identification.identificationTime', 'date');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey] = apiKey.split('.');
        const _v = subKey && data[type] ? data[type][subKey] : data[apiKey];

        _transform = {
            ..._transform,
            [uiKey]: _v === null ? kycState[uiKey] : _v,
        };
    });

    return _transform;
}
